/**
 * Created by Timur on 01.09.2026
 */

const Merge2MissionRewardType = {
    getIcon: function (value) {
        const period = Merge2MissionHelper.getCurrentPeriod();
        const gameIcon = bundles.merge.frames[`merge2mission_${period}_${Merge2MissionFamilies.getId(value.code, value.stage)}_png`];

        if (gameIcon && cleverapps.bundleLoader.isLoaded("merge")) {
            return gameIcon;
        }

        return Merge2MissionFamilies.getIcon(value.code, value.stage);
    },

    collect: function (reward, source, options) {
        if (RewardsList.isEmpty(reward)) {
            return;
        }

        const { animation, ...rewardOptions } = options || {};

        const rewards = new RewardsList(reward, { toBubbleStack: true, ...rewardOptions });
        rewards.receiveRewards();
        rewards.collectRewardsAnimation(source, animation);
    }
};

Reward.register("merge2MissionItems", {
    countable: true,
    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,

    getIcon: Merge2MissionRewardType.getIcon,

    getSmallIcon: Merge2MissionRewardType.getIcon,

    sumValues: function (value, other) {
        const result = cleverapps.toArray(other || []).map((item) => ({ ...item }));

        cleverapps.toArray(value).forEach((item) => {
            const same = result.find((added) => Merge2MissionFamilies.isSameItem(added, item));

            if (same) {
                same.amount += item.amount;
            } else {
                result.push({ ...item });
            }
        });

        return result;
    },

    parse: function (items, options) {
        if (!cleverapps.missionManager.findRunningMission(Mission.TYPE_MERGE2_MISSION)) {
            return [];
        }

        return items.map((item, index) => {
            const value = {
                code: item.code,
                stage: item.stage,
                amount: item.amount,
                batch: index === 0 ? items : undefined,
                toString: function () {
                    return String(this.amount);
                }
            };

            return new Reward("merge2MissionItems", value, options);
        });
    },

    receive: function (value, options) {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_MERGE2_MISSION);
        if (!value.batch || !mission) {
            return function () {};
        }

        mission.logic.pushDrops(value.batch, options.itemId || options.event);
        mission.logic.update();

        return function () {};
    }
});
